import { Model as MCModel, Collection as MCCollection } from 'vue-mc';
import { config as defaultConfig } from '@/config';
import { app } from '@/models/Application';
import { Debouncer } from './Debouncer';

function applyConfig(config: any) {
    const user = app.loginService.currentUser();
    config.baseURL = defaultConfig.baseUrl;
    if (user) {
        config.headers.Authorization = 'Bearer ' + user.access_token;
    }
    return config;
}

export class Model extends MCModel {
    constructor(config: any, collection: any) {
        super(config, collection);
    }

    public getRequest(config: any) {
        return super.getRequest(applyConfig(config));
    }

    public save(): Promise<any> {
        return super.save();
    }
}

export class Collection<T = any> extends MCCollection {

    public search: string = "";

    private debouncer = Debouncer.createDefault();

    public doSearch(search: string) {
        if (this.search !== search) {
            this.search = search;
            this.debouncer.update(() => {
                this.fetchData();
            });
        }
    }

    public getFetchQuery() {
        const obj = super.getFetchQuery();
        if (this.search) {
            obj.search = this.search;
        }
        return obj;
    }

    public getRequest(config: any) {
        return super.getRequest(applyConfig(config));
    }

    public find(obj: any) {
        return super.find(obj);
    }

    public fetch(obj?: any): Promise<any> {
        return super.fetch(obj);
    }

    public fetchData(): Promise<any> {
        return this.fetch();
    }

    public refreshData(): Promise<any> {
        return this.fetch();
    }

    public findByID(id: string | number): Promise<T> {

        const modelID = parseInt(id as string, 10);

        return new Promise(async (resolve, reject) => {
            try {
                const result = await this.fetchData();
                const model = this.find({ id: modelID });
                resolve(model);
            } catch (e) {
                reject(e);
            }
        });
    }
}
